export { default as Tile, type TileProps } from './Tile';
